import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconThread: React.FC<CentralIconBaseProps> = (props) => {
  return (
    <CentralIconBase {...props} ariaLabel="thread">
      <path
        d="M6 4V8.5M6 4H5M6 4H11M6 8.5V13.5M6 8.5L18 10.5M6 13.5V20M6 13.5L18 15.5M6 20H5M6 20H11M18 10.5V4M18 10.5V15.5M18 4H19M18 4H13M18 15.5V20M18 15.5L21 16M18 20H19M18 20H13M11 4V3.5C11 2.94772 11.4477 2.5 12 2.5C12.5523 2.5 13 2.94772 13 3.5V4M11 4H13M11 20V20.5C11 21.0523 11.4477 21.5 12 21.5V21.5C12.5523 21.5 13 21.0523 13 20.5V20M11 20H13"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </CentralIconBase>
  );
};

export default IconThread;
